define("shared/components/shared/wizard/slide-count", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <span class="tOB--wizard__counter">
    {{@slideProgressString}}
  </span>
  */
  {
    "id": "BbaWTmuw",
    "block": "[[[10,1],[14,0,\"tOB--wizard__counter\"],[12],[1,\"\\n  \"],[1,[30,1]],[1,\"\\n\"],[13]],[\"@slideProgressString\"],false,[]]",
    "moduleName": "shared/components/shared/wizard/slide-count.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});